import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Redirect, Switch as SwitchRoute } from 'react-router-dom';
import SiderBar from './SiderBar'
import paths from './paths.js';
import { inscreverAcesso, pode } from '../services/acesso';
import NaoEncontrado from '../containers/NaoEncontrado';

// Rota final: sem login vai para /login; logado, mostra "página não disponível"
// (antes, rota inexistente ou sem permissão renderizava uma tela em branco).
const RotaFallback = () => (
    localStorage.getItem("access_token")
        ? <NaoEncontrado />
        : <Redirect to="/login" />
);

const rotaLiberada = (route) => {
    if (route.publico) return true;
    if (!localStorage.getItem("access_token")) return false;
    if (!route.acao) return true;
    return pode(route.acao);
};

const Routes = () => {
    const [versao, setVersao] = useState(0);

    useEffect(() => inscreverAcesso(() => setVersao((valor) => valor + 1)), []);

    return (
        <Router>
            <SiderBar paths={paths} acessoVersao={versao}>
                <SwitchRoute>
                    {
                        paths.map((route) => {
                            if (!rotaLiberada(route)) return null;
                            return (
                                <Route key={route.to} path={route.to} exact component={route.container} />
                            );
                        })
                    }
                    <Route component={RotaFallback} />
                </SwitchRoute>
            </SiderBar>
        </Router>
    );
}

export default Routes;
